import { inject, Injectable } from '@angular/core';
import { disableGoogleAnalytics, initializeGoogleAnalyticsForClient } from './google-analytics';
import { initializeFacebookPixel } from './facebook-pixel';
import { initializeGTM } from './google-tag-manager';
import { SettingsService } from '../settings/settings.service';
import { Angulartics2 } from 'angulartics2';
import { logMsg } from '@app/shared/utils/logger';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private settingsService = inject(SettingsService);
  private angulartics = inject(Angulartics2);

  private trackingEnabled = false;

  public toggleTracing(enable: boolean): void {
    enable ? this.startTracking() : this.stopTracking();
  }

  private startTracking(): void {
    if (this.trackingEnabled) { return; }

    logMsg(TrackingService, 'Start');

    const settings = this.settingsService.settings;

    if (settings.ga_tracking_id) {
      initializeGoogleAnalyticsForClient(
        settings.ga_tracking_id,
        settings.ga_linker_enabled,
        settings.ga_linker_domains,
      );
    }
    if (settings.fb_tracking_id) {
      initializeFacebookPixel(settings.fb_tracking_id);
    }
    if (settings.gtm_tracking_id) {
      initializeGTM(settings.gtm_tracking_id);
    }

    this.notifyAngulartics(true);
    // this is very hacky because `clearUrl` method is protected in angulartics...
    // https://github.com/angulartics/angulartics2/blob/master/src/lib/core/angulartics2-core.ts#L83
    // @ts-ignore
    this.angulartics.pageTrack.next({ path: this.angulartics.clearUrl(location.pathname) });

    this.trackingEnabled = true;
  }

  private stopTracking(): void {
    if (!this.trackingEnabled) { return; }

    logMsg(TrackingService, 'Stop');

    this.notifyAngulartics(false);

    const settings = this.settingsService.settings;
    if (settings.ga_tracking_id) {
      disableGoogleAnalytics(settings.ga_tracking_id);
    }

    this.trackingEnabled = false;
  }

  private notifyAngulartics(enabled: boolean): void {
    this.angulartics.eventTrack.next({
      action: 'cookie_consents_update',
      properties: {
        category: 'cookie_consents_update',
        label: 'Cookie consents update',
        gtmCustom: { cookie_consent: enabled.toString() },
      },
    });
  }
}
